import React from 'react';

function SelectionSummary({ selected }) {
  if (!selected.length) return null;

  return (
    <section className="selection-summary">
      <div>
        <span>SELECȚIE MANUALĂ</span>
        <strong>{selected.length}/3 VARIANTE</strong>
      </div>
      <p>
        Ai marcat variantele cu scorurile comparative cele mai potrivite
        pentru analiza ta.
      </p>
      <div className="selection-list">
        {selected.map((variant) => (
          <div key={variant.id}>
            {variant.numbers.map((number) => (
              <b key={number}>{String(number).padStart(2, '0')}</b>
            ))}
            <span>{variant.confidenceScore}%</span>
          </div>
        ))}
      </div>
    </section>
  );
}

export default SelectionSummary;